import React from "react";

import { OrderTagFilters } from "./shared/order-tag-filters";
import { useTikTokShopTagInclusions } from "./use-tik-tok-shop-order-tag-inclusions";

export function TikTokShopOrderTags() {
  const {
    isSynced,
    loading,
    tikTokShopOrderTagInclusions,
    updateOrderTagByIndex,
    createOrderTagInclusion,
    removeOrderTagInclusion,
  } = useTikTokShopTagInclusions();

  return (
    <OrderTagFilters
      title="TikTok order tags"
      subheader="You can use order tags to tag certain purchases as TikTok shop purchases."
      description="Tag TikTok Shop orders with the following tags from your Northbeam data"
      isSynced={isSynced}
      loading={loading}
      addButtonText="ADD INCLUSION"
      tagFilters={tikTokShopOrderTagInclusions}
      updateTagFilters={updateOrderTagByIndex}
      createTagFilters={createOrderTagInclusion}
      removeTagFilters={removeOrderTagInclusion}
    />
  );
}
